// Archivo is the Guiders theme font ($family-primary). Loads it once,
// however many components ask for it.
const FONT_URL = 'https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;600;700;800&display=swap';

export default function loadThemeFont() {
  if (typeof document === 'undefined') return;
  if (document.querySelector(`link[href="${FONT_URL}"]`)) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = FONT_URL;
  document.head.appendChild(link);
}
